<ng-content></ng-content>
<div
  [class]="'ant-ribbon ' + presetColor && 'ant-ribbon-color-' + presetColor"
  [class.ant-ribbon-placement-end]="nzPlacement === 'end'"
  [class.ant-ribbon-placement-start]="nzPlacement === 'start'"
  [style.background-color]="!presetColor && nzColor">
  <ng-container *nzStringTemplateOutlet="nzText">{{ nzText }}</ng-container>
  <div class="ant-ribbon-corner" [style.color]="!presetColor && nzColor"></div>
</div>
